/**
 * Quick add to cart from product cards.
 *
 * Delegated handler for [data-quick-add] buttons (rendered by
 * snippets/product-grid-item.liquid for single-variant products).
 * On success it dispatches a `cart:added` CustomEvent so the cart
 * drawer (assets/cart-drawer.js) can open; without a drawer it simply
 * updates the header cart count in place.
 */
(function() {
  'use strict';

  var liveRegion = null;

  function announce(message) {
    if (!liveRegion) {
      liveRegion = document.createElement('span');
      liveRegion.className = 'visually-hidden';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = message;
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden-count', cart.item_count === 0);
        });
      })
      .catch(function() { /* count refresh is best-effort */ });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(btn.getAttribute('data-quick-add'), 10);
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    announce('Adding to cart');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        btn.textContent = 'Added ✓';
        announce('Added to cart');
        updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:added', {
          detail: { source: 'quick-add', variantId: variantId }
        }));
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function(err) {
        console.error('Quick add failed:', err);
        btn.textContent = 'Try again';
        btn.disabled = false;
        announce('Could not add to cart');
      });
  });
})();
